import { ErroredModel } from "./ErroredModel";
import { PreferenceDisplay } from "./Preference";

export type Tag = ErroredModel & {
  uuid: string;
  text: string | null;
  preference_value: string;
  preference_color: string | null;
  preference_uuid: string;
  parent_uuid?: string;
};

export type TaggableModel = {
  tags: Tag[];
};

export const tagToDisplay = (tag: Tag): PreferenceDisplay => ({ value: tag.preference_value, color: tag.preference_color });
